<div class="printButton">
    <mat-icon class="example-icon text-green-700 cursor-pointer" aria-hidden="false" matTooltip="Print" i18n-tooltip="Print" svgIcon="mat_solid:print" 
    (click)="onClick($event)"></mat-icon>
</div>
